import "flowbite";
import Alpine from "alpinejs";
window.axios = require("axios");
window.Alpine = Alpine;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
Alpine.start();
